<template>
  <v-navigation-drawer :value="getMHDInventoryDrawerState" class="cartDrawer inventory-drawer"
                       stateless temporary app right>
    <v-card class="three-color-grad cartDrawerWrapper mhd-inventory">
      <v-toolbar color="transparent" elevation="0" class="cartContentHeader mhd-inventory" height="70">
        <v-btn fab small class="closeCartBtn" @click="closeInventoryDrawer">
          <close-btn/>
        </v-btn>
        <v-toolbar-title class="pl-3 text--black">
          MHD-Inventur
        </v-toolbar-title>
      </v-toolbar>
      <v-container class="cartContentWrapper" v-if="getMHDInventoryDrawerState">

        <span v-if="getMHDInventoryItems.length === 0" class="emptyCartInfo">
          Du hast noch keine Artikel zur MHD-Inventurliste hinzugefügt.
        </span>

        <v-virtual-scroll class="inventory-list_v-scroll" item-height="181"
                          bench="2"
                          :items="getMHDInventoryItems"
                          v-if="getMHDInventoryItems.length > 0"
        >
          <template v-slot:default="{index, item}">
            <v-card class="article-card_no-img" :key="index">
              <div class="article-card__desc-no-img">
                {{ item.description }}
              </div>
              <div class="article-card__itemNo-no-img">
                Artikelnummer: {{ item.itemNo }}
              </div>
              <div class="article-card__ordered-type-no-img">
                {{ item.amount }} {{ item.unit | capitalize}}
              </div>
              <div class="article-card__price-no-img">
                  Ablaufdatum:  {{ parseDateToUsable(item.mhdDate) }}
              </div>
            </v-card>
            <v-btn class="v-scroll_btn-delete" @click="removeFromMHDInventoryList(index)">
              <TrashCan/>
            </v-btn>
          </template>

        </v-virtual-scroll>

      </v-container>
      <v-card elevation="10" class="cartBottomCard" light>
        <v-container class="cartBottomWrapper" style="height:100%;">
          <v-row class="pt-2">
            <v-col cols="12">
              <v-btn class="textSize__16 checkOutBtn"
                     @click="goToMHDInventoryCheckout"
              >
                <mdh-icon style="width: 40px; color:white;"/>
                <span class="pl-3 text--white">
                  Zur gesamten MHD-Kontrollliste
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import CloseBtn from "@/assets/closeBtn";

import TrashCan from "@/assets/cart/trashCan";
import router from "@/router";
import MdhIcon from "@/assets/mhd/mdhIcon.vue";

export default {
  name: "mhdInventoryDrawer",
  components: {MdhIcon, TrashCan, CloseBtn},

  data() {
    return {
      inventory: null,
      value: null,
    }
  },

  mounted() {
    this.fetchPersonalMHDControlList()
  },

  methods: {
    ...mapActions({
      setLoadingState: 'setLoadingState'
    }),

    ...mapActions('mhdInventory', {
        fetchPersonalMHDControlList: 'fetchPersonalMHDControlList',
        removeItemFromMhdInventory: 'removeItemFromMhdInventory'
    }),

    ...mapMutations('mhdInventory', {
        setMHDInventoryDrawerState: 'setMHDInventoryDrawerState'
    }),

    parseDateToUsable(value) {
        if(!value) {
            return
        }
        let splitted = value.toString().split('-')
        return splitted[2]+'.'+splitted[1]+'.'+splitted[0]
    },

    removeFromMHDInventoryList(index) {
      this.removeItemFromMhdInventory(index)
    },

    closeInventoryDrawer() {
      this.setMHDInventoryDrawerState(false)
    },

    goToMHDInventoryCheckout() {
      router.push({name: 'MHDControlCheckout'})
      this.setMHDInventoryDrawerState(false)
    },

  },

  computed: {
    ...mapGetters('mhdInventory', {
        getMHDInventoryDrawerState: 'getMHDInventoryDrawerState',
        getMHDInventoryItems: 'getMHDInventoryItems'
    }),

    ...mapGetters({
      getLoadingState: 'getLoadingState',
      getUserId: 'getUserId'
    })
  }
}
</script>

<style>


  .mhd-inventory .inventory-list_v-scroll {
      height: calc(100vh * 0.98 - 70px - 65px);
  }
  .article-card_no-img {
    border-radius: 30px 0px 0px 30px!important;
    height: 169px;
    width: 100%;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 33px 39px 33px 40px;
    background-color: white;
    border-radius: 30px;
    overflow: hidden;
    padding: 12px 16px;
  }

  .article-card__image {
    height: 40px;
    width: 40px;
    background-color: gray;
    grid-row-start: 1;
    grid-row-end: 5;
    grid-column-start: 1;
    grid-column-end: 1;
    margin-top: 4px;
  }

  .article-card__desc-no-img {
    border-top-left-radius: unset!important;
    font-size: 16px;
    color: var(--igros-black);
    grid-row-start: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .article-card__itemNo-no-img {
    font-size: 14px;
    color: var(--igros-black);
    grid-row-start: 2;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
  }

  .article-card__price-single-no-img {
    font-size: 22px;
    color: #525252;
    grid-row-start: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    font-weight: 700;
    align-self: center;
    text-align: left;
  }

  .article-card__ordered-type-no-img {
    font-size: 14px;
    color: var(--igros-black);
    grid-row-start: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    font-weight: 700;
    align-self: center;
    text-align: left;
  }

  .article-card__price-no-img {
    grid-row-start: 4;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
  }

  .article-card__price-no-img .total-price {
    font-size: 22px;
    color: #525252;
    font-weight: 700;
  }

  .article-card__price-no-img .single-price {
    margin-left: 10px;
    font-size: 12px;
    color: var(--igros-black);
  }

  .inventory-drawer {
    min-width: 320px;
  }

  .cartContentHeader.mhd-inventory .v-toolbar__content {
      justify-content: flex-start;
    flex-direction: row;
  }
  .mhd-inventory.cartDrawerWrapper {
      min-width: 100%;
      min-height: 100%;
      max-height: 96% ;
      padding: 0px;
      display: grid;
      overflow: scroll;
      grid-template-rows: [cartHeader] 70px [cartContentStart] calc(100% - 70px - 60px) [cartContentEnd] 60px [cartWrapperEnd];
      grid-template-columns: 100%;
  }
</style>
